import React from 'react';
import ReactTable from "react-table";

import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';
import config from 'src/config'
import Sublogin from "src/components/elements/sublogin"

const defaultColumnWidth = 57;

import { TableComponent, connect } from "src/components/tableComponent";

class Component extends TableComponent {

  initialState = {
    name: "",
    type: "all",
    affType: "affiliates",
    list: "",
    list_affiliates: {},
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day'),
    only_sales: true,
    expand: true    
  }

  getInitialState = (initialState)=> {
    if (this.props.user.role_id >= 3) {
      initialState.expand = false
      initialState.only_sales = true
      // initialState.from = moment().subtract(1, 'month')
      initialState.from = moment().isoWeekday(1);
    } else {
      initialState.expand = true
      initialState.only_sales = false
      initialState.from = moment().isoWeekday(1);
    }
    return initialState
  }

  fetchParams = (state) => {
    return {
      affType: this.props.state.affType || "affiliates",
      only_sales: this.props.state.only_sales,
      load_all: this.props.state.only_sales      
    }
  }

  state = this.initialState

  componentWillMount2() {
    if (this.props.apiListsState.initial) {
      this.props.api("mailer/getLists").then(res => {
        
      });
    }
    this.setState({
      name: ""
    })
    if (this.props.state.affType == "custom") {
      this.showCustom()
    }
  }

  makeColumns = () => {    
    var columns;
    var expand = this.props.state.expand || this.props.state.initial;
    if (this.props.state.initial && this.props.user.role_id >= 3) {
      expand = false;
    }
    if (expand) {
      columns = [
        {
          Header: "Wid",
          accessor: "aid",
          minWidth: 50,
          Footer: props => <span>Total</span>
        }, {
          Header: props => "Name / Reg date",
          accessor: "name",
          minWidth: 150,
          Cell: props => <div>{props.value} <br /> {moment(props.original.date*1000).format("D MMM YYYY")}</div>,
          Footer: props => <span>{this.props.total.count || 0}</span>
        }, {
          Header: props => "Email / Skype",
          accessor: "email",
          minWidth: 180,
          Cell: props => <div>{props.value} <br /> {props.original.skype != props.original.email ? props.original.skype : ""}</div>
        }, {
          Header: "Today",
          accessor: "today_dollars",
          minWidth: 130,
          Cell: props => 
            <div>
              <div>{props.original.today_sales || 0} sales / $ {props.original.today_dollars || 0}</div>
              <div>{props.original.today_visits || 0} visits / {props.original.today_unique || 0} uniq</div>
            </div>,
          Footer: props => 
            <div>
              <div>$ {this.props.total.today_dollars || 0}</div>
              <div>{this.props.total.today_sales || 0} sales</div>
              <div>{this.props.total.today_visits || 0} visits</div>
              <div>{this.props.total.today_unique || 0} unique</div>
            </div>
        }, {
          Header: "Yesterday",
          accessor: "yesterday_dollars",
          minWidth: 130,
          Cell: props => 
            <div>
              <div>{props.original.yesterday_sales || 0} sales / $ {props.original.yesterday_dollars || 0}</div>
              <div>{props.original.yesterday_visits || 0} visits / {props.original.yesterday_unique || 0} uniq</div>
            </div>,
          Footer: props => 
            <div>
              <div>$ {this.props.total.yesterday_dollars || 0}</div>
              <div>{this.props.total.yesterday_sales || 0} sales</div>
              <div>{this.props.total.yesterday_visits || 0} visits</div>
              <div>{this.props.total.yesterday_unique || 0} unique</div>
            </div>
        }, {
          Header: "Last week",
          accessor: "week_dollars",
          minWidth: 150,
          Cell: props => 
            <div>
              <div>{props.original.week_sales || 0} sales / $ {props.original.week_dollars || 0}</div>
              <div>{props.original.week_visits || 0} visits / {props.original.week_unique || 0} uniq</div>
            </div>,
          Footer: props => 
            <div>
              <div>$ {this.props.total.week_dollars || 0}</div>
              <div>{this.props.total.week_sales || 0} sales</div>
              <div>{this.props.total.week_visits || 0} visits</div>
              <div>{this.props.total.week_unique || 0} unique</div>
            </div>
        }, {
          Header: props => this.props.state.from.format("D MMM")+" - "+this.props.state.to.format("D MMM"),
          accessor: "between_dollars",
          minWidth: 150,
          Cell: props => 
            <div>
              <div>{props.original.between_sales || 0} sales / $ {props.original.between_dollars || 0}</div>
              <div>{props.original.between_visits || 0} visits / {props.original.between_unique || 0} uniq</div>
            </div>,
          Footer: props => 
            <div>
              <div>$ {this.props.total.between_dollars || 0}</div>
              <div>{this.props.total.between_sales || 0} sales</div>
              <div>{this.props.total.between_visits || 0} visits</div>
              <div>{this.props.total.between_unique || 0} unique</div>
            </div>
        }, {
          Header: "Add",
          id: "add",
          accessor: "aid",
          minWidth: 100,
          className: "text-center",
          Cell: props => this.props.list_affiliates[props.value] 
            ? <button class="btn danger" onClick={e => this.removeAffiliate(e,props.value,props.original.email)}>Remove</button> 
            : <button class="btn primary" onClick={e => this.addAffiliate(e,props.value,props.original.email)}>Add</button>
        }
      ]   
    } else {
      columns = [
        {
          Header: "Wid",
          accessor: "aid",
          minWidth: 50,
          Footer: props => <span>Total</span>
        }, {
          Header: props => "Name",
          accessor: "name",
          minWidth: 150,
          Cell: props => <div>{props.value}</div>,
          Footer: props => <span>{this.props.total.count || 0}</span>
        }, {
          Header: props => "Email ",
          accessor: "email",
          minWidth: 180
        }, {
          Header: "Today",
          accessor: "today_dollars",
          minWidth: 130,
          Cell: props => <div>{props.original.today_sales || 0} sales / $ {props.original.today_dollars || 0}</div>,
          Footer: props => <div>{this.props.total.today_sales || 0} sales <br /> $ {this.props.total.today_dollars || 0}</div>
        }, {
          Header: "Yesterday",
          accessor: "yesterday_dollars",
          minWidth: 130,
          Cell: props => <div>{props.original.yesterday_sales || 0} sales / $ {props.original.yesterday_dollars || 0}</div>,
          Footer: props => <div>{this.props.total.yesterday_sales || 0} sales <br /> $ {this.props.total.yesterday_dollars || 0}</div>
        }, {
          Header: "Last week",
          accessor: "week_dollars",
          minWidth: 150,
          Cell: props => <div>{props.original.week_sales || 0} sales / $ {props.original.week_dollars || 0}</div>,
          Footer: props => <div>{this.props.total.week_sales || 0} sales <br /> $ {this.props.total.week_dollars || 0}</div>
        }, {
          Header: props => this.props.state.from.format("D MMM")+" - "+this.props.state.to.format("D MMM"),
          accessor: "between_dollars",
          minWidth: 150,
          Cell: props => <div>{props.original.between_sales || 0} sales / $ {props.original.between_dollars || 0}</div>,
          Footer: props => <div>{this.props.total.between_sales || 0} sales <br /> $ {this.props.total.between_dollars || 0}</div>
        }, {
          Header: "Add",
          id: "add",
          accessor: "aid",
          minWidth: 100,
          className: "text-center",
          Cell: props => this.props.list_affiliates[props.value] 
            ? <button class="btn danger" onClick={e => this.removeAffiliate(e,props.value,props.original.email)}>Remove</button> 
            : <button class="btn primary" onClick={e => this.addAffiliate(e,props.value,props.original.email)}>Add</button>
        }
      ]         
    }

    if (this.props.user.role_id >= 3 && !expand && false) {
      columns.push({
        Header: "",
        accessor: "aid",
        id: "pay",
        sortable: false,
        minWidth: 80,
        Cell: props => <button class="btn btn-sm primary">Pay</button>        
      })
    } else {
      columns.push({
        Header: "",
        accessor: "aid",
        id: "pay",
        sortable: false,
        minWidth: 70,
        Cell: props => 
          <div>
            <div>
              <Sublogin aid={props.value} class="p-0" />
            </div>
            {expand &&
            <div>
              <Link 
                class="btn btn-sm btn-block warning mt-1 p-0"
                to={config.basePath+"/affiliate/"+props.value+"/sales"}
              >Sales</Link>
            </div>
            }
          </div>
      })    
    }
    return columns; 
  }

  apiPath = "master/stats"

  handleNameChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  createList = (e) => {
    e.preventDefault()
    if (!this.state.name) return;
    this.props.api("mailer/saveList",{name: this.state.name})
      .then(res => {
        if (res && res.result > 0) {
          this.setState({name: ""})
          this.props.api("mailer/getLists")
        }
      })
  }

  selectList = (e) => {
    let listId = e.target.value
    var affiliates = ""
    for (var i = 0; i < this.props.apiListsState.items.length; i++) {
      if (parseInt(this.props.apiListsState.items[i].id) == parseInt(listId)) {
        affiliates = this.props.apiListsState.items[i].content
      }
    }
    try {
      affiliates = affiliates ? JSON.parse(affiliates) : {}  
    } catch (err) {
      console.warn("mailer contant parse err:",err)
      affiliates = {}
    }
    console.log(affiliates)
    this.props.setState({
      list: listId,
      page: 0,
      list_affiliates: affiliates
    }, () => {
      this.setState(this.props.state)
    })
  }  

  addAffiliate = (e,aid,email) => {
    e.preventDefault()
    let affiliates = this.props.list_affiliates || {}
    affiliates[aid] = email
    this.props.setState({list_affiliates: affiliates}, () => {
      this.setState({list_affiliates: affiliates})
    })
    this.props.api("mailer/saveList",{
      id: this.props.state.list,
      content: JSON.stringify(this.props.list_affiliates)
    })
    let items = this.props.apiListsState.items
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == this.props.state.list) {
        items[i].content = JSON.stringify(this.props.list_affiliates)
        break
      }
    }
    this.props.changeList(items)
  }

  removeAffiliate = (e,aid) => {
    e.preventDefault()
    let affiliates = this.props.list_affiliates
    delete affiliates[aid]
    this.props.setState({list_affiliates: affiliates}, () => {
      this.setState({list_affiliates: affiliates})
    })  
    this.props.api("mailer/saveList",{
      id: this.props.state.list,
      content: JSON.stringify(this.props.list_affiliates)
    })
    let items = this.props.apiListsState.items
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == this.props.state.list) {
        items[i].content = JSON.stringify(this.props.list_affiliates)
        break
      }
    }
    this.props.changeList(items)     
  }

  tableParams = {
    manual: true,
    sorted: [{
      id: "aid",
      desc: true
    }],
    defaultPageSize: 50
  }

  typeOptions = [
    { name: "All links", value: "all"},
    { name: "HLinks", value: "chatsales"},
    { name: "KLinks", value: "chris"},
    { name: "EasySX", value: "easysex"},
    { name: "C.link.old", value: "chris2"},
    { name: "IFramecash", value: "sexplaycam"},
    { name: "Livecam", value: "imlive"},
    { name: "CeVIP", value: "cevip"},
    { name: "Wellhello", value: "wellhello"},
  ]

  showCustom = (e) => {
    e && this.changeType(e,true);
    let custom = "";
    for (var aid in this.props.list_affiliates) {
      custom += this.props.list_affiliates[aid]+"\r\n"
    }    
    this.setState({custom})
  }

  saveCustom = (e) => {
    let custom = this.state.custom.replace(new RegExp("\r","g"),"").split("\n").filter(email => email.trim().indexOf("@") != -1)
    let emailsHash = {}
    for (var i = 0; i < custom.length; i++) {
      let email = custom[i];
      var exist = false
      for (var aid in this.props.list_affiliates) {
        if (this.props.list_affiliates[aid] == email) {
          emailsHash[aid] = email
          exist = true;
          break;
        }
      }
      if (!exist) emailsHash[email] = email    
    }
    this.props.setState({list_affiliates: emailsHash}, () => {
      this.setState({list_affiliates: emailsHash})
    })   
    this.props.api("mailer/saveList",{
      id: this.props.state.list,
      content: JSON.stringify(emailsHash)
    })
    let items = this.props.apiListsState.items
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == this.props.state.list) {
        items[i].content = JSON.stringify(emailsHash)
        break
      }
    }
    this.props.changeList(items) 
  }

  render() {
    let listAffiliates = [];
    for (var aid in this.props.list_affiliates) {
      listAffiliates.push({
        aid: parseInt(aid) ? aid : "",
        email: this.props.list_affiliates[aid]
      })
    }
    let affType = this.props.state.affType
    return (
      <div class="affiliates-page">
        <div class="row">
          <div class="col-sm">
            <select
              class="form-control form-control-sm" 
              name="list" 
              value={this.props.state.list} 
              onChange={e => this.selectList(e,true)}              
            >
              <option value=""></option>
              {this.props.apiListsState.items.map((item) => 
                <option key={item.id} value={item.id}>{item.name}</option>
              )}
            </select>            
          </div>
          <div class="col-sm">
            {this.props.state.list && 
              <button class="btn primary">Remove</button>
            }
          </div>
          <div class="col-sm">
            <input 
              type="text" 
              class="form-control" 
              name="name" 
              onChange={this.handleNameChange} 
              value={this.state.name} 
              placeholder="list name"
              required
            />
          </div>
          <div class="col-sm">
            <button class="btn primary" onClick={this.createList}>Add</button>
          </div>          
        </div>     
        {this.props.state.list && 
          <div>
            <div class="row table-head-controls mt-4">
              <div class="col-sm">
                {this.props.user.role_id >= 3 &&
                <div class="btn-group">
                  {this.typeButton("Added","added","",(e) => {
                    this.changeType(e,true)
                  }, "affType")}
                  {this.typeButton("Custom","custom","",this.showCustom, "affType")}                  
                  {this.typeButton("Admins","admins","",null,"affType")}
                  {this.typeButton("Masters","masters","",null,"affType")}
                  {this.typeButton("Affiliates","affiliates","",null,"affType")}
                  {this.typeButton("Agents","agents","",null,"affType")}
                  {false && this.typeButton("Banned","banned","",null,"affType")}
                </div>
                }
              </div>
            </div>
            {affType != 'custom' && affType != 'added' &&
              <div class="row table-head-controls mt-2">
                <div class="col-10">
                  {this.datepickerElement()} 
                  {this.props.user.role_id >= 2 &&
                    <div class="d-inline-block ml-2">
                      <label class="ui-switch ui-switch-md info m-t-xs table-head-switch">
                        <input type="checkbox" name="only_sales" checked={this.props.state.only_sales} onChange={this.changeType} />              
                        <i></i>
                      </label>
                      <span class="ml-1 switch-description">Active affiliates</span>
                    </div> 
                  }
                  <div class="d-inline-block ml-2">
                    <label class="ui-switch ui-switch-md info m-t-xs table-head-switch">
                      <input type="checkbox" name="expand" checked={this.props.state.expand} onChange={e => this.changeType(e,true)} />     
                      <i></i>         
                    </label>            
                    <span class="ml-1 switch-description">Expand</span>          
                  </div>  
                  {this.props.user.role_id >= 3 &&
                  <select class="form-control form-control-sm table-select mr-4 pull-right" onChange={this.changeType} name="type">
                    {this.typeOptions.map(offer =>
                      <option key={offer.value} value={offer.value}>{offer.name}</option>
                    )}
                  </select>              
                  }                               
                </div>
                <div class="col-2">{this.props.state.type != "added" && this.searchElement()}</div>
              </div>
            }
            <div class="row">
              <div class="col-12">
                {affType == "custom" && 
                  <div class="box mt-2 p-2">
                    <textarea 
                      class="form-control" 
                      name="custom" 
                      value={this.state.custom} 
                      onChange={this.handleNameChange} 
                      onBlur={this.saveCustom}
                      rows="30"
                    />
                  </div>
                }
                {affType == "added" && 
                  <div class={"box mt-2"}>
                    <div class="row">
                      <div class="col-sm">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>aid</th>
                              <th>email</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {listAffiliates.map((aff) =>
                              <tr key={aff.aid}>
                                <td>{aff.aid}</td>
                                <td>{aff.email}</td>
                                <td>
                                  <button class="btn primary" onClick={e => this.removeAffiliate(e,aff.aid || aff.email,aff.email)}>
                                    Remove
                                  </button>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div> 
                  </div>
                }
                <div class={"box mt-2 "+(affType == "added" || affType == "custom" ? "hidden" : "")}>{this.reactTable()}</div>
              </div>
            </div>
          </div>
        }
      </div>   
    );
  }
}

export default connect(Component,"master_stats",function(state){
  return {
    apiListsState: state.api.mailer_getLists || state.api.initial,
    apiChangeState: state.api.affiliates_edit || state.api.initial,
    list_affiliates: state.state.master_stats && state.state.master_stats.list_affiliates || {}
  }
}, {
  changeList: function(items) {
    return (dispatch) => {
      dispatch({
        type: "api_success",
        key: "mailer_getLists",
        items: items
      })
    }    
  }
})